function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberlistBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11774"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3175",
    transform: "translate(5.538 9.231)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h6.462v.923H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3176",
    transform: "translate(5.538 1.846)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h6.462v.923H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11000",
    d: "M5.846 7.692V4h-.923v.462H4v.923h.923v2.307H4v.923h2.769v-.923z",
    style: {
      fill: "#203662"
    },
    transform: "translate(-4 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11001",
    d: "M6.769 22.615H4v-1.846a.923.923 0 0 1 .923-.923h.923v-.923H4V18h1.846a.923.923 0 0 1 .923.923v.923a.923.923 0 0 1-.923.923h-.923v.923h1.846z",
    transform: "translate(-4 -10.615)",
    style: {
      fill: "#203662"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberlistBlue);
export default __webpack_public_path__ + "static/media/NumberlistBlue.10af94ed6a62c658a5e27c9adc0f4d26.svg";
export { ForwardRef as ReactComponent };